import React from 'react';
import { ModalImageStyle } from './style';

export default function ModalImageDash({ close, src, alt, width = '100%', height = 'auto' }) {
  return (
    <ModalImageStyle width={width} height={height}>
      <img src={src} alt={alt} />
      <button onClick={() => close(false)}>Fechar</button>
    </ModalImageStyle>
  );
}
